import { ApiHatasi } from "./api";

/**
 * EKRANDA GÖSTERİLECEK HATA CÜMLESİ — istek kimliğiyle birlikte
 *
 * ================================================================
 * KİMLİK ÜRETİLİYOR, TAŞINIYOR, SON ADIMDA DÜŞÜYORDU
 * ================================================================
 * Sunucu her yanıta `X-Istek-Id` koyuyor
 * (`context.middleware.ts:35`) ve `request-context.ts` onun ne işe
 * yaradığını yazıyor: *"bir tıklamanın doğurduğu bütün olayları"*
 * birbirine bağlıyor.
 *
 * `Hata500.dc.html` çizimi onu ekranda **istiyor**:
 *
 *   > "Sorun sürerse bu kimliği iletin: req_9f4c21a8 · 02.09.2026 14:37"
 *
 * Ölçüldü (05.09.2026): **hiçbir istemci başlığı okumuyordu** — panel
 * de dahil. Yani bir şey bozulduğunda öğrencinin söyleyebileceği tek
 * şey *"bir hata aldım"* oluyordu ve destek tarafının o isteği
 * kayıtlarda bulmasının bir yolu yoktu.
 *
 * Tam olarak bu belgede kovaladığımız sınıf, en can sıkıcı yerinde:
 * arızayı teşhis edilebilir kılmak için üretilmiş alan, **arıza
 * anında** düşüyor.
 *
 * ================================================================
 * YALNIZCA 5xx'TE — VE SEBEBİ
 * ================================================================
 * 4xx'te mesaj zaten kullanıcının yapabileceği bir şeyi anlatıyor
 * ("kod yanlış", "bu ay hakkın bitti"). Oraya teknik bir kimlik
 * eklemek gürültü olurdu ve gürültü, gerçekten gerektiği yerde
 * kimliğin okunmamasına yol açar.
 *
 * 5xx'te kullanıcının yapabileceği bir şey yok; tek işe yarar bilgi
 * o kimlik.
 */
export function hataMetni(err: unknown, varsayilan: string): string {
  if (err instanceof ApiHatasi) {
    if (err.sunucuArizasiMi && err.istekId) {
      /*
        Kimlik CÜMLENİN SONUNDA ve ne işe yaradığı yazılı. Yalnızca
        kodu basmak, öğrenciye anlamını bilmediği bir dizi vermek
        olurdu — kimse onu kimseye iletmezdi.
      */
      return `${err.message} Sorun sürerse bu kimliği ilet: ${err.istekId}`;
    }
    return err.message;
  }
  return err instanceof Error ? err.message : varsayilan;
}
